var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"myCanvas",staticClass:"canvas-box",staticStyle:{"width":"100%","height":"100%","display":"flex","justify-content":"center","align-items":"center"}})
}
var staticRenderFns = []

export { render, staticRenderFns }